// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xM_sS","colMin":"styles_colMin__1eHUP"};